const UUID_RE = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';

export interface BookingWidgetRoute {
  token: string;
}

/** Public availability widget URL — at site root, embeddable via iframe. */
export function buildBookingWidgetUrl(token: string): string {
  const base =
    (import.meta.env.VITE_LOYALTY_JOIN_ORIGIN as string | undefined)?.replace(/\/$/, '') ||
    (typeof window !== 'undefined' ? window.location.origin : '');
  return `${base}/book/${token}`;
}

/** Iframe snippet customers paste into their site. */
export function buildBookingWidgetEmbed(token: string): string {
  return `<iframe src="${buildBookingWidgetUrl(token)}" style="width:100%;min-height:880px;border:0;border-radius:20px;overflow:hidden" loading="lazy" title="Book a room"></iframe>`;
}

/** Widget token from `/book/{uuid}` path or `#/book/{uuid}` hash. */
export function getBookingWidgetRoute(): BookingWidgetRoute | null {
  if (typeof window === 'undefined') return null;

  const pathMatch = window.location.pathname.match(new RegExp(`^/book/(${UUID_RE})$`, 'i'));
  if (pathMatch?.[1]) return { token: pathMatch[1].toLowerCase() };

  const hash = window.location.hash.replace(/^#\//, '').split('?')[0] ?? '';
  const hashMatch = hash.match(new RegExp(`^book/(${UUID_RE})$`, 'i'));
  if (hashMatch?.[1]) return { token: hashMatch[1].toLowerCase() };

  return null;
}
